module.exports = __webpack_public_path__ + "img/select-arrow.8b3e941f.svg";